import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const DeleteTermMutation = graphql.persisted(
  "DeleteTerm",
  graphql(`
    mutation DeleteTerm($input: DeleteTermInput!) {
      deleteTerm(input: $input) {
        success
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { DeleteTermMutation };

export function useDeleteTerm() {
  return useMutation(DeleteTermMutation);
}
